import classNames from 'classnames';
import { useEffect } from 'react';
import LazyLoad from 'react-lazyload';

import { Layout, Space, Typography } from '@sravni/react-design-system';
import { Image } from '@sravni/react-image';
import { useBoolean } from '@sravni/react-utils';

import { ebsImagePng } from '@src/assets';
import { sendClickEbsBanner, sendOpenEbsBanner } from '@src/helpers/analyticsEvents';
import { isServer } from '@src/utils';

import { EbsDialogBanner } from '../EbsDialogBanner/EbsDialogBanner';

import { EbsBannerTexts } from './EbsBanner.texts';
import styles from './EsbBanner.module.scss';

const LazyPixel = () => {
  useEffect(() => {
    if (isServer) {
      return;
    }
    sendOpenEbsBanner();
  }, []);

  return null;
};

export function EbsBanner() {
  const [isShow, setShow] = useBoolean(false);

  const handleClose = () => {
    setShow.off();
  };

  const handleOpenModal = () => {
    sendClickEbsBanner();
    setShow.on();
  };

  return (
    <>
      <LazyLoad>
        <LazyPixel />
      </LazyLoad>
      <Layout className={classNames('layout', styles.outsideContainer)} onClick={handleOpenModal}>
        <div className={styles.container}>
          <Space direction="column" size={4}>
            <Typography.Heading as="div" level={5} className={classNames('h-color-static-light', styles.heading)}>
              {EbsBannerTexts.heading}
            </Typography.Heading>
            <Typography.Text as="div" className={classNames('h-color-static-light', styles.subtitle)}>
              {EbsBannerTexts.description}
              <span className={styles.helper}>{EbsBannerTexts.howToDo}</span>
            </Typography.Text>
          </Space>
          <Space className={styles.imageContainer}>
            <Image src={ebsImagePng} />
          </Space>
        </div>
      </Layout>
      <EbsDialogBanner visible={isShow} onClose={handleClose} data={undefined} onOverlayClick={handleClose} />
    </>
  );
}
